import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "ly-col ly-center-center totp-container" }
const _hoisted_2 = { class: "mt-2 w-35 ly-container large-number-container mfa-input-container" }
const _hoisted_3 = {
  key: 0,
  class: "msg msg-error w-100 text-center"
}
const _hoisted_4 = { class: "ly-row mt-2 ly-even-2" }

import { ref, computed, inject, Ref } from 'vue'
import { Redirect } from '@/types/redirect'


export default /*@__PURE__*/_defineComponent({
  __name: 'TOTPView',
  setup(__props) {

const code: Ref<string> = ref('')
const totpLoginFlow = inject('totpLoginFlow') as (code: string) => Promise<void>
const redirect = inject('redirect') as Redirect

const submitting: Ref<boolean> = ref(false)
const errorMessage = ref('')

const formSubmitted = async () => {
  if (submitting.value) return
  submitting.value = true
  errorMessage.value = ''

  try {
    await totpLoginFlow(code.value)
  } catch (error) {
    errorMessage.value = 'Invalid MFA Code. The code you entered is incorrect or has expired.'
  }
  submitting.value = false
}

const goBack = () => {
  redirect('LoginView')
}

const disableForm = computed(() => !code.value || submitting.value)

return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "card",
      onSubmit: _withModifiers(formSubmitted, ["prevent"])
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-center" }, "Multi-factor Authentication", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center" }, "Enter the code generated in your authenticator app ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_lp_input, {
          modelValue: code.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
          "max-length": 6,
          compact: "",
          class: "text-center font-weight-bold",
          placeholder: "______"
        }, null, 8, ["modelValue"])
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          onClick: goBack,
          type: "button"
        }, "Cancel"),
        _createVNode(_component_lp_button, {
          disabled: disableForm.value,
          loading: submitting.value,
          class: "btn-loading-active",
          type: "primary"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Verify", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ]))
}
}

})